export const UPLOAD = {
  page: 'upload-page',
  patientNameInput: 'upload-patient-name-input',
  dropZone: 'upload-drop-zone',
  fileInput: 'upload-file-input',
  removeFileButton: 'upload-remove-file-button',
  analyzeButton: 'upload-analyze-button',
  analyzingState: 'upload-analyzing-state',
  analyzingMessage: 'upload-analyzing-message',
  errorMessage: 'upload-error-message',
};

export const REPORT = {
  page: 'report-page',
  backButton: 'report-back-button',
  shareButton: 'report-share-button',
  shareModal: 'report-share-modal',
  shareToggle: 'report-share-toggle',
  shareLinkInput: 'report-share-link-input',
  shareCopyButton: 'report-share-copy-button',
  shareEmailInput: 'report-share-email-input',
  shareSendButton: 'report-share-send-button',
  shareSendSuccess: 'report-share-send-success',
  shareSendError: 'report-share-send-error',
  downloadButton: 'report-download-button',
  overviewSection: 'report-overview-section',
  markersSection: 'report-markers-section',
  markersTable: 'report-markers-table',
  markerRow: 'report-marker-row',
  findingsSection: 'report-findings-section',
  summarySection: 'report-summary-section',
  recommendationsSection: 'report-recommendations-section',
  notesSection: 'report-notes-section',
  notesEditButton: 'report-notes-edit-button',
  notesTextarea: 'report-notes-textarea',
  notesSaveButton: 'report-notes-save-button',
  notesDisplay: 'report-notes-display',
};

export const PUBLIC_REPORT = {
  page: 'public-report-page',
  downloadButton: 'public-report-download-button',
  markersTable: 'public-report-markers-table',
  signUpBanner: 'public-report-signup-banner',
  ctaButton: 'public-report-cta-button',
};
